export const dynamicImporting = () =>
	Promise.all([
		import(/* webpackPreload: true, webpackChunkName: "predefined" */ './predefined.js'),
		import(/* webpackPreload: true */ './i18n.js'),
	]);
